import { z } from "@/zod";
import {
  apartmentNumber,
  city,
  phoneNumberOptional,
  postalCode,
  streetName,
  streetNumber,
} from "./commonFields";

export const address = z.object({
  city: city,
  street_name: streetName,
  street_number: streetNumber,
  apartment_number: apartmentNumber.nullish(),
  postal_code: postalCode,
  province_id: z.string().min(1),
  province: z.string().min(1),
  contact_person: z.string().nullish(),
  email: z.string().nullish(),
  phone_number: phoneNumberOptional,
});
